import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";
import { Observable } from "rxjs/internal/Observable";

@Injectable({
  providedIn: "root",
})
/* La clase `TitleWrapperService` es responsable de configurar y notificar a sus suscriptores del título de una página web.
   Es un wrapper del servicio nativo de Angular "Title" con el objetivo de notificar de los cambios. */
export class TitleWrapperService {
  private titleSubject = new BehaviorSubject<string>("");

  constructor(private titleService: Title) {}

  /**
   * La función establece el título de una página web y notifica a los suscriptores del nuevo título.
   * @param {string} newTitle - El nuevo título que desea establecer para la página. Debería ser un
   * valor de cadena.
   */
  setTitle(newTitle: string): void {
    this.titleService.setTitle(newTitle);
    this.titleSubject.next(newTitle);
  }

  /**
   * La función `getTitle()` devuelve un Observable que emite el valor actual de `titleSubject` como
   * una cadena.
   * @returns El método `getTitle()` devuelve un `Observable` de tipo `string`.
   */
  getTitle(): Observable<string> {
    return this.titleSubject.asObservable();
  }
}
